import React from 'react';

import '../../static/css/main.css'
import '../../static/fonts/stylesheet.css'
import { CalcBody, Contacts } from './calcBody';
import { useDispatch, useSelector } from 'react-redux';
import { selectProcessCalc, selectStepCalc, setStepCalc } from './calcSlice';
import { setCalcPage } from '../home/homeSlice';

export function Calc() {
    const dispath = useDispatch()

    const stepCalc = useSelector(selectStepCalc)
    const processCalc = useSelector(selectProcessCalc)

    const handleClickObject = () => {
        if (processCalc === 'contacts' || processCalc === 'data_person' || processCalc === 'contract') return
        dispath(setStepCalc('object'))
    }

    const handleClickPerson = () => {
        // if (processCalc === 'contacts') return
        dispath(setStepCalc('data_person'))
    }

    const handleClickContract = () => {
        if (processCalc === 'contacts' || processCalc === 'data_person') return
        dispath(setStepCalc('contract'))
    }

    const handleClickBackPreCalc = () => {
        dispath(setCalcPage('precalc'))
    }


    return (
        <>
            <section class="section-calculator" id="section-calculator">
                <div class="conteiner">
                    <div class="section-calculator-contant" data-da=".section-calculator,428,0">
                        <div onClick={handleClickBackPreCalc} class="section-calculator-link">Расчет стоимости</div>
                        <div class="section-calculator-tab">

                            <div class="section-calculator-tab-title">
                                <div onClick={handleClickPerson} 
                                    class={"section-calculator-tab-title-item " + (stepCalc === 'data_person' ? 'section-calculator-tab-title-item-1': '')}
                                >
                                    Заемщик
                                </div>
                                <div onClick={handleClickContract}
                                    class={"section-calculator-tab-title-item section-calculator-tab-title-item-2 "  + (stepCalc === 'contract' ? 'section-calculator-tab-title-item-1': '')}
                                >
                                    Ипотечный договор
                                </div>
                                <div onClick={handleClickObject} 
                                    class={"section-calculator-tab-title-item section-calculator-tab-title-item-3 "  + (stepCalc === 'object' ? 'section-calculator-tab-title-item-1': '')}
                                >
                                    Объект
                                </div>
                                <div
                                    class={"section-calculator-tab-title-item section-calculator-tab-title-item-4 "  + (stepCalc === 'buy' ? 'section-calculator-tab-title-item-1': '')}
                                >
                                    Покупка
                                </div>
                            </div>

                            {/* CONTACTS */}
                            <CalcBody/>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}



